import type { WorkZone } from '$lib/types';

export interface ZoneDistance {
  zone: WorkZone;
  distance: number;
}

export interface WorkZoneMatch {
  nearest: ZoneDistance | null;
  containing: ZoneDistance | null;
}

// Keep the browser's site decision aligned with internal/workzone: containment
// is checked before choosing the nearest matching zone.
export function workZoneMatch(zones: WorkZone[], lat: number, lng: number): WorkZoneMatch {
  let nearest: ZoneDistance | null = null;
  let containing: ZoneDistance | null = null;
  for (const zone of zones) {
    const distance = haversineMeters(lat, lng, zone.latitude, zone.longitude);
    const candidate = { zone, distance };
    if (!nearest || distance < nearest.distance) nearest = candidate;
    if (distance <= zone.radius && (!containing || distance < containing.distance)) containing = candidate;
  }
  return { nearest, containing };
}

function haversineMeters(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const toRad = (degrees: number) => (degrees * Math.PI) / 180;
  const deltaLat = toRad(lat2 - lat1);
  const deltaLng = toRad(lng2 - lng1);
  const a =
    Math.sin(deltaLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(deltaLng / 2) ** 2;
  return 6_371_000 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
